import QuizLayoutWrapper from './QuizLayoutWrapper';

export default QuizLayoutWrapper;
